import script from "./KPosButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./KPosButton.vue?vue&type=script&setup=true&lang=ts"

import "./KPosButton.vue?vue&type=style&index=0&id=4c8cdec2&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c8cdec2"]])

export default __exports__